import {
  ArrowClockwise,
  ChartLine,
  CaretRight,
} from "@phosphor-icons/react";
import { Button } from "../ui/button";
import { getRiskColor, getRiskIconColor, getProbabilityColor, getTextPrimary, getTextSecondary, getCardClass } from "../../lib/styleHelpers";
import { OpportunityDetail } from "./OpportunityDetail";
import { RecentSidebar } from "./RecentSidebar";

export function DashboardTab({
  todaysOpportunity,
  opportunities,
  generating,
  generateOpportunity,
  selectedOpportunity,
  setSelectedOpportunity,
  stats,
  isDark,
  watchlistIds,
  toggleWatchlist,
}) {
  const opp = selectedOpportunity || todaysOpportunity;

  return (
    <div className="animate-fade-in" data-testid="dashboard-content">
      {/* Quick Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <StatCard label="Total Generated" value={stats?.total_opportunities || 0} icon={ChartLine} isDark={isDark} testId="stat-total" />
        <StatCard label="Avg. Confidence" value={`${stats?.average_confidence || 0}%`} icon={ChartLine} isDark={isDark} testId="stat-confidence" />
        <StatCard label="High Probability" value={stats?.high_probability_count || 0} icon={ChartLine} isDark={isDark} testId="stat-high-prob" />
        <div className={`p-4 rounded-xl border ${getCardClass(isDark)}`}>
          <Button
            onClick={generateOpportunity}
            disabled={generating}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white rounded-lg"
            data-testid="generate-btn"
          >
            <ArrowClockwise size={18} className={`mr-2 ${generating ? "animate-spin" : ""}`} />
            {generating ? "Generating..." : "Generate Now"}
          </Button>
        </div>
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          {opp ? (
            <OpportunityDetail
              opportunity={opp}
              getRiskColor={getRiskColor}
              getRiskIconColor={getRiskIconColor}
              getProbabilityColor={getProbabilityColor}
              isDark={isDark}
              watchlistIds={watchlistIds}
              onToggleWatchlist={toggleWatchlist}
            />
          ) : (
            <EmptyState isDark={isDark} generating={generating} onGenerate={generateOpportunity} />
          )}
        </div>
        <div className="hidden lg:block">
          <RecentSidebar
            opportunities={opportunities}
            selectedOpportunity={selectedOpportunity}
            setSelectedOpportunity={setSelectedOpportunity}
            getProbabilityColor={getProbabilityColor}
            watchlistIds={watchlistIds}
            isDark={isDark}
          />
        </div>
      </div>
    </div>
  );
}

function StatCard({ label, value, icon: Icon, isDark, testId }) {
  return (
    <div className={`p-4 rounded-xl border ${getCardClass(isDark)}`}>
      <div className="flex items-center gap-2 mb-1">
        <Icon size={16} className={getTextSecondary(isDark)} />
        <span className={`text-xs font-body ${getTextSecondary(isDark)}`}>{label}</span>
      </div>
      <p className={`text-2xl font-bold ${getTextPrimary(isDark)}`} data-testid={testId}>{value}</p>
    </div>
  );
}

function EmptyState({ isDark, generating, onGenerate }) {
  return (
    <div className={`rounded-xl p-12 text-center border ${getCardClass(isDark)}`} data-testid="empty-state">
      <ChartLine size={48} className={`mx-auto mb-4 ${isDark ? "text-gray-700" : "text-gray-300"}`} />
      <h2 className={`text-xl font-bold mb-3 ${getTextPrimary(isDark)}`}>No Opportunities Yet</h2>
      <p className={`font-body mb-6 ${getTextSecondary(isDark)}`}>
        Generate your first AI-powered investment opportunity
      </p>
      <Button onClick={onGenerate} disabled={generating} className="bg-purple-600 hover:bg-purple-700 text-white rounded-lg px-8" data-testid="generate-first-btn">
        <CaretRight size={18} className="mr-2" />Generate Opportunity
      </Button>
    </div>
  );
}
